import { PRIMARY_COLOR } from '../../config/color';

export const AssistantsFloat = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    viewBox="0 0 42 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1144_48351)">
      <path
        d="M0.3 30.3462C0.134315 30.3462 0 30.2119 0 30.0462V25.2934C0 25.1277 0.134315 24.9934 0.3 24.9934H5.08739H8.12519L12.3342 22.3371L13.1532 17.9929C13.1563 17.9764 13.158 17.9597 13.1583 17.9429L13.2126 15.0524L12.1146 7.2042L8.23499 5.35284H5.08739H0.3C0.134314 5.35284 0 5.21853 0 5.05284V0.3C0 0.134315 0.134315 0 0.3 0H8.19839C11.6754 0 14.2374 0.764693 15.9942 3.42099C17.6046 5.87605 18.3732 9.01532 18.3732 15.0524C18.3732 21.2504 17.2752 24.9531 15.1524 27.4484C13.2858 29.6218 11.1264 30.3462 7.97879 30.3462H0.3ZM8.12519 24.9934C10.1382 24.9934 11.4192 24.3092 12.3342 22.3371C13.1394 20.6064 13.2126 17.9501 13.2126 15.0524C13.2126 11.9131 13.176 9.01532 12.1146 7.2042C11.1996 5.63457 9.88199 5.35284 8.23499 5.35284L12.1146 7.2042L13.2126 15.0524L13.1583 17.9429C13.158 17.9597 13.1563 17.9764 13.1532 17.9929L12.3342 22.3371L8.12519 24.9934Z"
        fill="white"
      />
      <rect y="9.98438" width="4.40956" height="10.3816" rx="0.3" fill="white" />
      <path
        d="M28.7633 30.1908C28.7425 30.2817 28.6616 30.3462 28.5683 30.3462H18.6284C18.4967 30.3462 18.401 30.2211 18.4353 30.094L26.5294 0.147817C26.5529 0.0605875 26.6321 0 26.7224 0H33.1709C33.2612 0 33.3404 0.0605864 33.364 0.147816L41.458 30.094C41.4923 30.2211 41.3966 30.3462 41.2649 30.3462H36.3353L36.6268 28.4331C36.6407 28.3416 36.5901 28.2526 36.5045 28.2177L29.8353 25.5037L28.7633 30.1908ZM24.8855 25.5037L29.8353 25.5037L36.5045 28.2177C36.5901 28.2526 36.6407 28.3416 36.6268 28.4331L36.3353 30.3462L29.8353 6.07729L24.8855 25.5037Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1144_48351"
        x="0"
        y="0"
        width="41.9648"
        height="30.8477"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.5" dy="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.356255 0 0 0 0 0.337028 0 0 0 0 0.474365 0 0 0 0.17 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1144_48351" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1144_48351"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const AssistantsExpand = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    viewBox="0 0 32 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1144_49082)">
      <path d="M32 2L17 17L2 2" stroke="white" stroke-width="4" shape-rendering="crispEdges" />
    </g>
    <defs>
      <filter
        id="filter0_d_1144_49082"
        x="0.585938"
        y="0.585938"
        width="33.3281"
        height="19.7422"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.5" dy="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.356255 0 0 0 0 0.337028 0 0 0 0 0.474365 0 0 0 0.17 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1144_49082" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1144_49082"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const AssistantsPlus = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5672 8.89841L3.22602 0.557266C2.63664 -0.0321094 1.65627 -0.0321094 1.06689 0.557266C0.673016 1.14664 0.673016 2.12702 1.06689 2.71639L9.40787 11.0574L1.26234 19.2016C0.672969 19.791 0.672969 20.7714 1.26234 21.3608C1.85172 21.9501 2.83209 21.9501 3.42147 21.3608L11.567 13.2165L19.7113 21.3608C20.3006 21.9501 21.281 21.9501 21.8704 21.3608C22.4598 20.7714 22.4598 19.791 21.8704 19.2016L13.7263 11.0575L22.0687 2.71639C22.4597 2.12702 22.4597 1.14664 22.0687 0.557266C21.4793 -0.0321094 20.499 -0.0321094 19.9096 0.557266L11.5672 8.89841Z"
      fill="#262626"
    />
  </svg>
);

export const AssistantsHot = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 16.5C12.088 16.5 14.6249 14.0528 14.6249 10.9118C14.6249 10.1407 14.5857 9.31406 14.1583 8.02935C13.7309 6.74468 13.6448 6.57885 13.1928 5.78546C12.9998 7.40453 11.9666 8.0793 11.7042 8.28097C11.7042 8.07116 11.0792 5.75096 10.1316 4.36271C9.20137 3 7.93628 2.10597 7.19449 1.5C7.19449 2.65116 6.87071 4.36271 6.40702 5.23478C5.94334 6.10684 5.85626 6.1386 5.27707 6.78758C4.69792 7.43655 4.43209 7.63699 3.94778 8.42441C3.46349 9.21187 3.375 10.2607 3.375 11.0318C3.375 14.1728 5.91199 16.5 9 16.5Z"
      fill="#FF8301"
      stroke="#FF8301"
      stroke-linejoin="round"
    />
  </svg>
);

export const AssistantsArrowRight = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.75 0.5L6.25 6L0.75 11.5" stroke="currentColor" />
  </svg>
);

export const AssistantsLike = ({
  active = false,
  class: className,
  onClick,
}: {
  active: boolean;
  class: string;
  onClick: () => void;
}) =>
  active ? (
    <svg
      class={className}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3501 6.97501V4.27501C10.3501 3.15662 9.44348 2.25 8.32508 2.25L5.62508 8.32501V15.75H13.4686C14.1417 15.7576 14.7177 15.2681 14.8186 14.6025L15.7501 8.52751C15.8095 8.1359 15.694 7.73795 15.4341 7.43907C15.1742 7.1402 14.7962 6.97051 14.4001 6.97501H10.3501Z"
        fill="#0F5EF7"
        stroke="#0F5EF7"
      />
      <path
        d="M5.625 8.25022H3.82275C3.032 8.23623 2.35601 8.89125 2.25 9.67496V14.4C2.35601 15.1837 3.032 15.7639 3.82275 15.75H5.625V8.25022Z"
        stroke="#0F5EF7"
      />
    </svg>
  ) : (
    <svg
      class={className}
      onClick={onClick}
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3501 5.97501V3.27501C10.3501 2.15662 9.44346 1.25 8.32506 1.25L5.62506 7.32501V14.75H13.4686C14.1417 14.7576 14.7176 14.2681 14.8186 13.6025L15.7501 7.52751C15.8095 7.1359 15.694 6.73795 15.4341 6.43907C15.1742 6.1402 14.7961 5.97051 14.4001 5.97501H10.3501Z"
        stroke="#9E9E9E"
      />
      <path
        d="M5.625 7.25022H3.82275C3.032 7.23623 2.35601 7.89125 2.25 8.67496V13.4C2.35601 14.1837 3.032 14.7639 3.82275 14.75H5.625V7.25022Z"
        stroke="#9E9E9E"
      />
    </svg>
  );

export const AssistantsDislike = ({
  active = false,
  class: className,
  onClick,
}: {
  active: boolean;
  class: string;
  onClick: () => void;
}) =>
  active ? (
    <svg
      class={className}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3501 11.025V13.725C10.3501 14.8434 9.44346 15.75 8.32506 15.75L5.62506 9.67499V2.24999H13.4686C14.1417 2.24238 14.7176 2.7319 14.8186 3.39749L15.7501 9.47249C15.8095 9.8641 15.694 10.2621 15.4341 10.5609C15.1742 10.8598 14.7961 11.0295 14.4001 11.025H10.3501Z"
        fill="#EF4343"
        stroke="#EF4343"
      />
      <path
        d="M5.625 9.74978H3.82275C3.032 9.76377 2.35601 9.10875 2.25 8.32504V3.60004C2.35601 2.81629 3.032 2.23605 3.82275 2.25004H5.625V9.74978Z"
        stroke="#EF4343"
      />
    </svg>
  ) : (
    <svg
      class={className}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3501 11.025V13.725C10.3501 14.8434 9.44348 15.75 8.32508 15.75L5.62508 9.67499V2.24999H13.4686C14.1417 2.24238 14.7177 2.7319 14.8186 3.39749L15.7501 9.47249C15.8095 9.8641 15.694 10.2621 15.4341 10.5609C15.1742 10.8598 14.7962 11.0295 14.4001 11.025H10.3501Z"
        stroke="#9E9E9E"
      />
      <path
        d="M5.625 9.74978H3.82275C3.032 9.76377 2.35601 9.10875 2.25 8.32504V3.60004C2.35601 2.81629 3.032 2.23605 3.82275 2.25004H5.625V9.74978Z"
        stroke="#9E9E9E"
      />
    </svg>
  );

export const AssistantTriangle = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 12V0L0.885799 5.24074C0.420188 5.63984 0.420188 6.36016 0.8858 6.75926L7 12Z"
      fill="#EEF0F4"
    />
  </svg>
);
export const AssistantPause = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8.5" r="6.5" stroke={PRIMARY_COLOR} />
    <rect x="6" y="6.5" width="4" height="4" fill={PRIMARY_COLOR} />
  </svg>
);

export const AssistantAIGenerated = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.99894 15.5C9.07248 15.5 10.9081 14.1 10.9081 8.5C10.9081 2.9 9.07248 1.5 7.99894 1.5C6.92544 1.5 5.08984 2.99434 5.08984 8.5C5.08984 14.0057 6.92544 15.5 7.99894 15.5Z"
      stroke="#666666"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.70139 12.1664C2.23816 13.1039 4.41564 13.9734 9.45434 11.0401C14.493 8.10678 14.8349 5.77055 14.2981 4.83312C13.7614 3.89568 11.499 3.07551 6.54524 5.95945C1.59141 8.84335 1.16464 11.229 1.70139 12.1664Z"
      stroke="#666666"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.70218 4.83312C1.16542 5.77055 1.50731 8.10678 6.54602 11.0401C11.5847 13.9734 13.7622 13.1039 14.2989 12.1664C14.8357 11.229 14.4089 8.84335 9.45509 5.95945C4.50129 3.07551 2.23895 3.89568 1.70218 4.83312Z"
      stroke="#666666"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const AssistantRefresh = (props: { class?: string; onClick?: () => void }) => (
  <svg
    class={props.class}
    onClick={props.onClick}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.773 13.773C12.5515 14.9945 10.864 15.75 9 15.75C5.27209 15.75 2.25 12.7279 2.25 9C2.25 5.27209 5.27209 2.25 9 2.25C10.864 2.25 12.5515 3.00552 13.773 4.22704C14.3947 4.84879 15.75 6.375 15.75 6.375"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.75 3V6.375H12.375"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
